
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      getProductTitle();
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {       
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    let customevent = this.debouncedOnChange.bind(this);

    // this.addEventListener('click', this.debouncedOnChange.bind(this));
    const listItems = this.querySelectorAll('.oneTimeOnly');   
 
    if( listItems.length > 0 ){
      listItems.forEach(function(listItem) {
        listItem.addEventListener('click', customevent);
      });
    }
    this.check();
  }
                                    
  onChange(event) {   

    var quantity = parseInt(document.getElementById('Drawer-quantity-'+event.target.dataset.index).value);
  
    let name = document.activeElement.getAttribute('name');
    
    if( event.target.dataset.upgrade_plan != null ){
        document.querySelector('#Selling-plan-'+event.target.dataset.index).value = event.target.dataset.upgrade_plan;  
        name = "selling_plan";
    }
    
    this.updateQuantity(event.target.dataset.index, quantity, name);
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }
  
  updateQuantity(line, quantity, name) {
  
    this.enableLoading(line);    
    const cartRecomendation = new Event("start");
    document.dispatchEvent(cartRecomendation);

    var selling_plan = null;

    if( ["subscribe", "selling_plan"].includes(name) ){
      const selectBox = document.getElementById('Selling-plan-'+line);
      if ( selectBox != null ) {
        const selectedOption = selectBox.options[selectBox.selectedIndex];
        selling_plan = selectedOption.value;
      }  
    } 
    
    const body = JSON.stringify({
    line,
    quantity,  
    sections: this.getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname,    
    ...(["subscribe", "selling_plan"].includes(name) && { selling_plan }),
    });

    /*
    const body = JSON.stringify({
      line,      
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });    
    */
    //fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    fetch(window.Shopify.routes.root + 'cart/change.js', { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        
        if( selling_plan != null ){
          document.querySelector('.cart-item__error').style.display = "none";
        }  
        
        
        this.disableLoading();
        this.check();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        // const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        //   errors.textContent = window.cartStrings.error;
        
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
     var variantId = '40235713101873';

    $.ajax({
      url: '/products.json?variant=' + variantId,
      dataType: 'json',
      success: function(response) {

        // var product = response.products[0];
        // console.log(product);
        // var title = product.title;
        // var description = product.body_html;
        // var image = product.images[0].src;

        // $('.free-product-title').text(title);
        // $('.free-product-description').html(description);
        // $(".free-product-image").attr("src", image);
      },
      error: function(xhr, status, error) {
        console.error(error);
      }
    });
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
    this.check();
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
  

    check(){
      let cartContainsFreeProduct = false;
      let cartContainsQualifyingProduct = false;
      const qualifyingProductVariantId = 39970851192881; 
      // const freeProductVariantId = 32551597277233;
      const freeProductVariantId = "";

      function checkCartItems() {
          jQuery.getJSON('/cart.js', function(cart) {
              cart.items.forEach(function(item) {
                  if (item.id === freeProductVariantId) {
                      cartContainsFreeProduct = true;
                  }
                  if (item.id === qualifyingProductVariantId) {
                      cartContainsQualifyingProduct = true;
                  }
              });

              if (cartContainsQualifyingProduct && !cartContainsFreeProduct) {
                  jQuery.post('/cart/add.js', { quantity: 1, id: freeProductVariantId })
                  .done(function() {
                      updateCart();
                  });
              }
          });

      }

      function updateCart() {
          jQuery.get('/cart', function(data) {
              var cartItemsHtml = jQuery(data).find('.cart-items').html();
              jQuery('.cart-items').html(cartItemsHtml);
          });
      }

      checkCartItems();
      setTimeout(() => {
        let bundleWrapper = document.querySelector('.drawer .bundle_wrapper');
        let bundleItems = document.querySelectorAll('.cart-item.item_has_bundle_discount');
        bundleItems.forEach(bundleItem =>  bundleWrapper.append(bundleItem));
      },500);

    }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};

window.freeProduct1 = 40235713101873;
window.freeProductThreshold = 15;
async function addFreeProducts() {
  await fetch(`${window.location.origin}/cart.js`)
      .then(async res => await res.clone().json()
          .then(async data => {
                let product1 = data.items.filter(function (item) {
                  return item.variant_id == freeProduct1
                });
                if (product1.length == 0) {
                    let cartDrawer = document.querySelector('cart-drawer');
                    if (!cartDrawer) {
                        console.error('Cart drawer element not found or not initialized');
                        return; // Exit if cart-drawer element is not found or not initialized
                    }
                    console.log('Adding free product to cart');
                    const response = await fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
                        items: [{
                          id: freeProduct1,
                          quantity: 1,
                          sections: cartDrawer.getSectionsToRender().map((section) => section.section),
                        }],
                      })
                    }).then((response) => response.json())
                      .then((response) => {
                        console.log("Response =>");
                        console.log(response);
                        console.log("call change event on drawer");
                        if (cartDrawer) {
                          cartDrawer.renderContents(response);
                          console.log(cartDrawer.renderContents(response));
                        }
                      });
                } else {
                  if (data.total_price == 0) {
                    const response = await fetch('/cart/update.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
                        updates: {
                          [freeProduct1]: 0,
                        },
                      })
                    });
                  }
                }
              }
          )
      );
}

// Wait for DOMContentLoaded event to ensure the cart-drawer element is available
document.addEventListener('DOMContentLoaded', (event) => {
  // Call addFreeProducts function after DOM content is loaded
  //addFreeProducts();
});

// Listen for the 'cart:item:add' event
document.addEventListener('cart:item:add', (event) => {
// Call addFreeProducts function whenever an item is added to the cart
  //addFreeProducts();
});

// window.freeProduct1 = 40235713101873;
// window.freeProductThreshold = 15;

const Cookies = {
  get: ( c_name ) => {
    let i, x, y, ARRcookies = document.cookie.split(";");
    for (i=0;i<ARRcookies.length;i++) {
      x = ARRcookies[i].substr( 0, ARRcookies[i].indexOf("=") );
      y = ARRcookies[i].substr( ARRcookies[i].indexOf("=") + 1 );
      x=x.replace( /^\s+|\s+$/g, "" );
      if ( x==c_name ) {
        return unescape( y );
      }
    }
  },
  set: ( c_name, value, exdays ) => {
    let exdate = new Date();
    exdate.setDate( exdate.getDate() + exdays );
    let c_value = escape( value ) + ( ( exdays==null ) ? "" : ";path=/; expires="+exdate.toUTCString() );
    document.cookie = c_name + "=" + c_value;
  }
}

window.ray = function (msg, color='purple') {
  debug = true;
  if (debug) {
    console.log('%c '+msg, 'background: '+color+'; color: white;');
  }
}

// document.addEventListener('rebuy:cart.change', (event) => {
//   addFreeProducts();
// });




setInterval(() => {
  var allRows = document.querySelectorAll('.cart-items tbody tr');
  var giftcardRows = document.querySelectorAll('.cart-items tbody tr.giftcard_product');
  if (allRows.length === giftcardRows.length) {
    var redeemfreeGift = document.querySelector('.cart-redeem-free-gift');
    if( redeemfreeGift ) {
      document.querySelector('.cart-redeem-free-gift').classList.add('only-gift-cards');
    }
  }
}, 100);



if (window.location.href === 'https://azoproducts.com/cart') {

    const subtotalElement = document.querySelector('.totals__subtotal-value');
    const checkoutButton = document.querySelector('#checkout');
    const cartBlocks = document.querySelector('.cart__blocks');

    function updateCheckoutButton() {
      const subtotalValue = parseFloat(subtotalElement.textContent.replace('$', '').replace(' USD', '').trim());
  
      if (subtotalValue > 0) {
        checkoutButton.disabled = false;
        cartBlocks.style.pointerEvents = 'auto';
      } else {
        checkoutButton.disabled = true;
        cartBlocks.style.pointerEvents = 'none'; 
      }
    }
    updateCheckoutButton();

    setInterval(function() {
      const GetsubtotalValue = parseFloat(subtotalElement.textContent.replace('$', '').replace(' USD', '').trim());
      if (GetsubtotalValue <= 0) {
        cartBlocks.style.pointerEvents = 'none';
      }
    }, 100);
}

window.onRemoveBundleItem = async (btn) => {
    let cartKeys = btn.dataset.lineItemKey.split('|');
    await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            updates: cartKeys.reduce((acc, line) => {
                acc[parseInt(line)] = 0;
                return acc;
            }, {})
        })
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        fetch('/cart')
          .then((response) => response.text())
          .then((data) => {
            let div = document.createElement('div');
            div.innerHTML = data;
            cart.innerHTML = div.querySelector('cart-drawer').innerHTML;
            if (response.item_count === 0) {
              cart.classList.add('is-empty');
              document.body.classList.add('overflow-hidden');
            }
            getRecomandProduct();
          });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
}